import { createContext, useContext } from 'react';
import { ScreenConfiguration } from '@/contexts/screenConfiguration.types';

const ScreenConfigurationContext = createContext<ScreenConfiguration | null>(null);

export const ScreenConfigurationProvider = ScreenConfigurationContext.Provider;

export const useScreenConfiguration = (): ScreenConfiguration => {
  const context = useContext(ScreenConfigurationContext);
  if (!context) {
    throw new Error('useScreenConfiguration must be used within ScreenConfigurationProvider.');
  }
  return context;
};

export default ScreenConfigurationContext;
